const mutations = {
  toggleMainPanel (state, val) {
    if (!state.isMainPanelOpen && !state.isDetailPanelOpen) {
      state.isDetailPanelOpen = true;
    }
// console.log(val);
    if (val === true || val === false) {
      state.isMainPanelOpen = val;
    } else {
      state.isMainPanelOpen = !state.isMainPanelOpen;
    }

  },
  toggleDetailPanel (state, val) {
    if (val === true || val === false) {
      state.isDetailPanelOpen = val;
    } else {
      state.isDetailPanelOpen = !state.isDetailPanelOpen;
    }
  },
  setLoading (state, val) {
    state.isLoading = val;
  },
  setLevels (state, levels) {
    state.levels = levels;
    // state.isMainPanelOpen = true;
  },
  setLevel (state, level) {
    state.selectedLevel = level;
  },
  setVenues (state, venues) {
    state.venues = venues;
  },
  setVenue (state, venue) {
    state.venue = venue;
    state.isDetailPanelOpen = true;
  },
  setImages (state, images) {
    state.images = images;
  },
  setPackages (state, packages) {
    state.packages = packages;
  },
  setPackageCategories (state, categories) {
    state.packageCategories = categories;
  },
  setSelectedPackageCategory (state, category) {
    state.selectedPackageCategory = category;
  },
  setPackage (state, pack) {
    state.selectedPackage = pack;
    state.isDetailPanelOpen = true;
  },
  setEnhancements (state, payload) {
    state.enhancements = payload;
  },
  toggleFullScreen (state) {
    state.isFullScreen = !state.isFullScreen;
  },
  setRootEl (state, val) {
    state.rootEl = val;
  }
}

export default mutations;
